// ag-grid-enterprise v19.1.4
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var colorScheme_1 = require("./colorScheme");
var fontScheme_1 = require("./fontScheme");
var formatScheme_1 = require("./formatScheme");
var themeElements = {
    getTemplate: function () {
        return {
            name: "a:themeElements",
            children: [
                colorScheme_1.default.getTemplate(),
                fontScheme_1.default.getTemplate(),
                formatScheme_1.default.getTemplate()
            ]
        };
    }
};
exports.default = themeElements;



//////////////////
// WEBPACK FOOTER
// ./~/_ag-grid-enterprise@19.1.4@ag-grid-enterprise/dist/lib/exporter/files/ooxml/themes/office/themeElements.js
// module id = 780
// module chunks = 5